import React from "react";
import { useTranslation } from "react-i18next";
import { capitalize } from "../../libraries/utils";
import Icon from "../../libraries/icons";
import ButtonIcon from "../commons/ButtonIcon";

export default function MedicamentCartElement({ medicament, ...rest }) {
  const { t, i18n } = useTranslation();
  return (
    <div
      key={rest.key}
      className={"flex items-center " + (rest.className ? rest.className : "")}
      onClick={rest.onClick && rest.onClick}
    >
      <div className="mr-auto">
        <h4>
          {capitalize(medicament.name)}
          {rest.prescription && <Icon className="h-4 w-4 text-primary inline-block ml-1" name="clipboard_list" />}
        </h4>
        <small className="text-gray-500">({capitalize(medicament.drug)})</small>
        <small className="text-gray-500 block">{capitalize(medicament.presentation)}</small>
        {(medicament.indication && !rest.editable) && (
            <p className="mt-3 italic">"{medicament.indication}"</p> 
        )}
      </div>
      {rest.selectable && (
        <Icon className="text-gray-400 h-4 w-4 mr-3" name="cheveron_right" />
      )}  
      {!rest.selectable && rest.editable && (
        <div className="flex items-center">
          <ButtonIcon
            buttonClassName="btn-ghost"
            icon="plus"
            onClick={()=>{rest.onChangeQuantity(medicament.id, medicament.quantity + 1)}}
          />
          <input 
            className="input input-bordered input-sm text-center shadow-none"
            key={rest.key} type="numeric" 
            onChange={(e) => {
              rest.onChangeQuantity(medicament.id, parseInt(e.target.value))
            }} 
            size={2}
            value={medicament.quantity ? medicament.quantity : ""}
            autoFocus={medicament.autoFocus}
            readOnly={true}
          />
          {
          <ButtonIcon
            buttonClassName="btn-ghost"
            icon="minus"
            onClick={()=>{
              if(medicament.quantity > 1){
                rest.onChangeQuantity(medicament.id, medicament.quantity-1)
              }
            }}
          />}
          <ButtonIcon
            className="w-5 h-5"
            buttonClassName="btn-ghost btn-sm"
            icon="trash"
            onClick={() => rest.onRemove(medicament.id)}
          />
        </div>
      )}
      {!rest.selectable && !rest.editable && <div className="shrink-0 ml-2">x{medicament.quantity}</div>}
    </div>
  )
}